import React from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import Contacts from 'components/UI/Contacts';
import Logos from './components/Logos';
import { useTrans } from 'utils/localisation';

import * as styles from './ModalAside.module.scss';

export default function DefaultAside({ className, title }) {
  const t = useTrans(['getConsultation', 'footer']);

  const customers = (
    <>
      <p className={styles.sectionTitle}>{t('clientsWhoTrustUs')}</p>
      <Logos />
    </>
  );

  return (
    <div className={cn(styles.wrapper, className)}>
      <section className={styles.section}>
        <Title size="h4" color="white">
          {title ?? t('defaultTitleForAside')}
        </Title>
      </section>
      <section className={styles.section}>
        <p className={styles.sectionTitle}>{t('contactUs')}</p>
        <Contacts className={styles.contacts} />
      </section>
      <section className={styles.section}>{customers}</section>
    </div>
  );
}
